export type CompSalesReportType = 'monthly' | 'daily'

export interface IComparePeriodItemDetails {
  period: number
  label?: string
  benchmark: any
}

export interface IComparePeriodItem {
  period: number
  label: string
  currentPeriod?: IComparePeriodItemDetails
  previousPeriod?: IComparePeriodItemDetails
  percentageDifference?: number
  shopIds?: string[]
  shopsCount?: number
}

export interface ICompareBenchmarkItem {
  title: string
  subtitle: string
  historySubtitle: string
  avgSales: IComparePeriodItem[]
  avgCarCount: IComparePeriodItem[]
  avgTicket: IComparePeriodItem[]
}

export interface ICompareResult {
  dayBenchmark: ICompareBenchmarkItem
  monthBenchmark: ICompareBenchmarkItem
}

export interface ICompareResponse {
  title: string
  subtitle: string
  dayBenchmark: ICompareBenchmarkItem
  monthBenchmark: ICompareBenchmarkItem
}

export interface ICompareFullResponse {
  title: string
  subtitle: string
  results: ICompareResult[]
}

export interface ICompSalesFilters {
  avgSalesPerDay?: boolean
  avgCarPerDay?: boolean
  avgTicket?: boolean
}
